import React from 'react'
import { Table } from 'Components/shared/table'

interface StatusProps {
  columnData: {
    columnName: string
    columnWidth?: number
    sortOrder?: string
    sortBy?: string
  }[]
  rows: any[]
  setSortOrder: any
}

export const Status = ({
  columnData,
  rows,
  setSortOrder,
}: StatusProps) => {
  return (
    <Table
      columnData={columnData}
      rows={rows}
      isSelectable={false}
      setSortOrder={setSortOrder}
    />
  )
}